import './App.scss';

import Routes from '@/routes/index';

import { Helmet } from 'react-helmet-async';
import OgImage from '@/assets/images/og-image.webp';

function App() {
	return (
		<div className="App">
			<Helmet>
				<title>미스터디벨로 - 의도한대로 만드는 개발사</title>
				<meta
					name="description"
					content="대기업부터 5성급 호텔, 스타트업까지 믿고 맡기는 IT 개발사"
				/>
				<meta property="og:image" content={OgImage} />
				<meta property="og:url" content={`${window.location.href}`} />
				<meta
					property="og:title"
					content={`미스터디벨로 - 의도한대로 만드는 개발사`}
				/>
				<meta
					property="og:description"
					content="대기업부터 5성급 호텔, 스타트업까지 믿고 맡기는 IT 개발사"
				/>

				<meta
					name="apple-mobile-web-app-title"
					content={`미스터디벨로 - 의도한대로 만드는 개발사`}
				/>
			</Helmet>
			<Routes />
		</div>
	);
}

export default App;
